import { type ReactNode, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { Chip } from 'shared/ui'
import styles from './styles.module.scss'

export const SingleRowWithPlus = <T extends { id: string | number }>({
  items,
  renderItem,
}: {
  items: T[]
  renderItem: (item: T) => ReactNode
}) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const itemsRefs = useRef<Map<string | number, HTMLDivElement>>(new Map())
  const [hiddenCount, setHideCount] = useState(0)

  useEffect(() => {
    if (ref.current) {
      const maxWidth = ref.current.offsetWidth - 40
      let currentWidth = 0
      let visibleElements = 0
      let hideCount = 0
      for (const item of items) {
        const itemElement = itemsRefs.current.get(item.id)
        if (itemElement) {
          currentWidth += itemElement.clientWidth
          if (currentWidth > maxWidth) {
            hideCount = items.length - visibleElements
            break
          } else {
            visibleElements += 1
          }
        }
      }
      setHideCount(hideCount)
    }
  }, [items, itemsRefs, ref])

  return (
    <div className={styles.wrap} ref={ref}>
      {items.map((item, index) => {
        const visibleCount = items.length - hiddenCount
        return (
          <div
            key={item.id}
            ref={(el) => el && itemsRefs.current.set(item.id, el)}
            className={classNames({ [styles.hidden]: index >= visibleCount })}
          >
            {renderItem(item)}
          </div>
        )
      })}
      {!!hiddenCount && <Chip label={`+${hiddenCount}`} />}
    </div>
  )
}
